.autocompleteOption {
  position: relative;
  padding: 0;
}
